/**
 * StaffHealthHub — IT-SCE Intern: "Plattform-Health"-Sektion mit Sub-Tabs.
 *
 * TQ #9697 (Staff-Migration Teil D, Bundle #9523, ZIELBILD-Unified-Cockpit).
 * Bündelt StaffSystemHealth + StaffVMs + StaffSync unter der Route
 * /staff/health (Sidebar-Link "Plattform-Health", Layout.tsx Zeile 367-370)
 * — mirrort das Hub-Muster aus customer-portal/src/pages/staff/
 * StaffHubPages.tsx, aber bewusst nur auf die 3 Teil-D-Seiten skaliert
 * (StaffCortex/StaffCortexPermissions/StaffAriaTenants sind Teil E, #9698).
 *
 * Routing: /staff/health, /staff/vms und /staff/sync rendern alle diesen
 * Hub (App.tsx); der aktive Tab wird aus dem Pfad abgeleitet.
 */

import { useLocation, useNavigate } from 'react-router-dom'
import StaffSystemHealth from './StaffSystemHealth'
import StaffVMs from './StaffVMs'
import StaffSync from './StaffSync'

interface Tab {
  id: string
  label: string
  icon: string
  path: string
}

const TABS: Tab[] = [
  { id: 'health', label: 'System-Health', icon: '🩺', path: '/staff/health' },
  { id: 'vms', label: 'VMs', icon: '🖧', path: '/staff/vms' },
  { id: 'sync', label: 'ERP-Sync', icon: '🔄', path: '/staff/sync' },
]

export default function StaffHealthHub() {
  const navigate = useNavigate()
  const path = useLocation().pathname
  const active = path.includes('/vms') ? 'vms' : path.includes('/sync') ? 'sync' : 'health'

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '2rem 1.5rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
        <a href="/" style={{ color: '#FF6B35', textDecoration: 'none', fontSize: '0.9rem' }}>
          ← Cockpit
        </a>
      </div>
      <h1 style={{ margin: 0, fontSize: '1.6rem' }}>🛠️ Plattform-Health</h1>

      <nav style={{ display: 'flex', gap: 4, marginTop: '1rem', marginBottom: '1.5rem', borderBottom: '1px solid #e5e7eb' }} role="tablist">
        {TABS.map(t => (
          <button
            key={t.id}
            role="tab"
            aria-selected={active === t.id}
            onClick={() => navigate(t.path)}
            style={{
              padding: '0.6rem 1rem',
              border: 'none',
              borderBottom: active === t.id ? '2px solid #FF6B35' : '2px solid transparent',
              background: 'none',
              color: active === t.id ? '#FF6B35' : '#374151',
              fontWeight: active === t.id ? 600 : 400,
              cursor: 'pointer',
              fontSize: '0.95rem',
            }}
          >
            <span aria-hidden>{t.icon}</span> {t.label}
          </button>
        ))}
      </nav>

      <div role="tabpanel">
        {active === 'health' && <StaffSystemHealth />}
        {active === 'vms' && <StaffVMs />}
        {active === 'sync' && <StaffSync />}
      </div>
    </div>
  )
}
